import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const homepageArticles = articles.filter((a) => a.slug !== 'vigorbuy-spreadsheet-guide');

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100/80 text-primary-700',
  accent: 'bg-accent-100/80 text-accent-700',
  secondary: 'bg-secondary-100/80 text-secondary-700',
};

export default function ArticleCTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-primary-700 bg-primary-100/80 rounded-full mb-3">
            SEO Articles
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Latest VigorBuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Dive deeper with our in-depth guides, category breakdowns, safety tips, and expert shopping resources.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10">
          {homepageArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline overflow-hidden"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={article.cardImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent" />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <div className="flex flex-wrap items-center gap-1.5 mb-2">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag.label}
                      className={`px-2 py-0.5 text-[10px] font-label font-semibold rounded-full ${colorMap[tag.color] || colorMap.secondary}`}
                    >
                      {tag.label}
                    </span>
                  ))}
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.summary}
                </p>
                <div className="flex items-center gap-1 text-xs text-primary-600 font-label font-medium">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm md:text-base font-label font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer no-underline"
          >
            Read Complete Beginner Guide
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}